import { SVGProps } from "react"

export function IconThumbsUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h500v500H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <circle cx="239.29" cy="244.202" r="177.173" fill="#c5d3d6" />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M300.668 62.786c16.337-11.094 39.808-10.421 65.856 4.618 49.16 28.383 88.879 97.186 88.719 153.674-.069 24.212-7.452 42.231-19.738 52.684l-44.602 27.505L266.18 84.069z"
        />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M332.697 88.218c49.16 28.383 88.879 97.186 88.719 153.674s-40.139 79.271-89.298 50.889c-49.16-28.383-88.885-97.182-88.725-153.671s40.145-79.275 89.305-50.892"
        />
        <path
          fill="#eef4f6"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M331.135 118.327c35.3 20.38 63.82 69.785 63.705 110.347s-28.822 56.921-64.121 36.541c-35.3-20.38-63.825-69.782-63.71-110.344s28.826-56.924 64.126-36.543"
        />
        <path
          fill="#fff"
          d="M297.837 120.531c-9.378 7.252-16.13 12.629-23.544 18.104v.004c-11.384-8.255-24.771-15.8-36.976-20.608-24.758-9.753-47.015-49.016-58.019-71.774-7.866-16.267-45.14-20.097-43.639 13.272s10.597 54.751 25.977 66.004 17.162 20.166 21.288 30.013c-10.176 3.582-54.768 18.753-72.399 45.387-7.729 17.338 0 36.762 3.001 39.763.723.723 4.342 2.926 9.551 5.884-6.926 2.556-19.782 12.497-15.886 31.628s10.461 19.319 18.714 22.883c-4.501 8.628-9.432 19.699-.798 33.505 5.016 8.021 12.004 10.054 23.771 14.417-1.089 3.427-3.09 20.813 14.54 27.29 18.189 6.682 55.143 26.634 69.398 15.755s37.376-23.07 37.325-38.263c-.014-4.15-.58-7.51-1.436-10.192 16.744-15.204 56.39-32.76 57.703-63.145 33.949-19.631 34.914-20.861 41.104-24.119 48.863-71.162-57.046-149.063-69.675-135.808"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M299.588 164.17c-7.878-15.38-37.512-36.387-62.27-46.14s-47.015-49.016-58.019-71.774c-7.866-16.267-45.14-20.097-43.639 13.272s10.597 54.751 25.977 66.004 17.162 20.166 21.288 30.013c-10.176 3.582-54.768 18.753-72.399 45.387-7.729 17.338 0 36.762 3.001 39.763s55.893 31.51 65.647 33.761c9.753 2.251 22.883 6.752 44.265-7.127 21.382-13.88 30.948-16.505 18.756-46.89-8.874-22.117-32.309-.52-38.804-2.169-7.711-1.958-20.278-2.895-29.343-16.337"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M123.078 246.58c-6.926 2.556-19.782 12.497-15.886 31.628s10.461 19.319 18.714 22.883 58.332 36.387 82.902 24.946c24.571-11.441 45.049-22.263 45.89-39.075.625-12.504 3.626-26.009-10.921-34.524"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M125.906 301.09c-4.501 8.628-9.432 19.699-.798 33.505 7.55 12.073 19.554 10.572 45.625 23.889s48.766 17.443 68.272-1.688 35.574-29.197 24.993-54.08c-4.609-10.838-9.724-12.488-9.724-12.488"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M148.879 349.012c-1.089 3.426-3.091 20.813 14.539 27.291 18.189 6.682 55.143 26.634 69.398 15.755s37.376-23.07 37.325-38.263c-.049-14.502-6.822-19.393-9.233-19.194"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M274.293 138.634c7.414-5.474 14.166-10.851 23.544-18.103 24.133-9.753 115.036 72.91 69.398 136.67-14.923 7.163-26.571 13.223-40.826 23.258-1.313 30.385-40.96 47.941-57.703 63.145"
        />
      </g>
    </svg>
  )
}
